// api/publicClient.js
const API_BASE = process.env.REACT_APP_API_BASE_URL || "/api";

async function publicRequest(path, options = {}, retries = 2, attempt = 0) {
  const { method = "GET", body, isFormData = false } = options;
  const headers = isFormData ? {} : { "Content-Type": "application/json" };
  
  try {
    const res = await fetch(`${API_BASE}/public${path}`, {
      method,
      headers,
      body: isFormData ? body : body !== undefined ? JSON.stringify(body) : undefined,
    });
    const data = await res.json().catch(() => null);
    if (!res.ok) throw new Error(data?.error || `Request failed (${res.status})`);
    return data;
  } catch (err) {
    const isNetworkFailure = err instanceof TypeError || err.message === "Failed to fetch";
    if (isNetworkFailure && retries > 0) {
      const baseDelay = 500 * Math.pow(2, attempt);
      const jitter = Math.random() * 250;
      await new Promise((r) => setTimeout(r, baseDelay + jitter));
      return publicRequest(path, options, retries - 1, attempt + 1);
    }
    throw err;
  }
}

export const publicApi = {
  getCustomer: (token) => publicRequest(`/customer/${token}/`),
  getCustomerByShortCode: (shortCode) => publicRequest(`/customer/short/${shortCode}/`),
  submitPayment: (token, formData) => publicRequest(`/customer/${token}/pay/`, { method: "POST", body: formData, isFormData: true }),
  analyzeReceipt: (token, formData) => publicRequest(`/customer/${token}/analyze-receipt/`, { method: "POST", body: formData, isFormData: true }),
  findAccount: (q) => publicRequest(`/find-account/search/?q=${encodeURIComponent(q)}`),
};

export function naira(n) {
  return "\u20a6" + Number(n || 0).toLocaleString("en-NG", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}